import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mb-1 tw-block tw-text-xs dark:tw-text-white"
}
const _hoisted_2 = ["value", "min", "max", "disabled", "title"]
const _hoisted_3 = {
  key: 1,
  class: "tw-mt-1 tw-text-2xs tw-text-red-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
        'tw-block tw-w-full tw-rounded-md tw-border tw-bg-white dark:tw-bg-black dark:tw-text-white': true,
        'focus-within:tw-ring-deep-orange-500 hover:tw-border-deep-orange-500 focus:tw-border-deep-orange-500':
          !_ctx.disabled,
        'tw-cursor-not-allowed tw-border-gray-300 tw-bg-gray-100 tw-text-gray-500 dark:tw-border-gray-700 dark:tw-bg-gray-800 dark:tw-text-gray-400':
          _ctx.disabled,
        'tw-border-red-300 dark:tw-border-red-700': _ctx.error
      })
    }, [
      _createElementVNode("input", {
        type: "date",
        value: _ctx.modelValue,
        min: _ctx.minDate,
        max: _ctx.maxDate,
        class: "tw-block tw-w-full tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-bg-white tw-p-2 placeholder:tw-text-slate-400 hover:tw-border-deep-orange-600 focus:tw-border-deep-orange-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-deep-orange-500 dark:tw-bg-black sm:tw-text-sm",
        disabled: _ctx.disabled,
        title: _ctx.disabledReason,
        "data-testid": "studio-date-input",
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
      }, null, 40, _hoisted_2)
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}